import * as React from 'react'

import { inject, observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import { getTransitionPath } from '~/client/src/shared/constants/commonRoutes'

import DesktopInitialState from '../../../stores/DesktopInitialState'
import NavBarStore from '../NavBar.store'

// localization: no display text to translate

interface INavBarItemProps {
  isHovering?: boolean
  isUnclickable?: boolean
  icon?: React.ReactNode
  badge?: string | number
  route?: string
  routeLabel?: string
  key?: string
  navBarStore: NavBarStore
  onClickHandler?: (event: React.SyntheticEvent) => void
  isActive?: boolean
  omitIfActive?: boolean

  state?: DesktopInitialState
  className?: string
  testId?: string
}

@inject('state')
@observer
export default class NavBarItem extends React.Component<INavBarItemProps> {
  public static defaultProps = {
    isHovering: true,
  }

  public render() {
    const {
      isHovering,
      isUnclickable,
      onClickHandler,
      routeLabel,
      icon,
      children,
      isActive,
      className,
      testId,
    } = this.props

    const active = isActive || this.isActive
    if (this.props.omitIfActive && active) {
      return null
    }

    return (
      <div
        className={classList({
          'navbar-item text large flex-unset nowrap no-select': true,
          'row x-center': !!icon,
          nohover: !isHovering,
          active,
          'unclickable-element': isUnclickable,
          [className]: !!className,
        })}
        onClick={onClickHandler || this.onClickDefault}
        data-testid={testId}
      >
        {children}
        {routeLabel}
        {this.icon}
      </div>
    )
  }

  private get icon(): React.ReactNode {
    const { badge, icon } = this.props

    if (!icon) return null

    if (!badge) return icon

    // Icon with badge
    return (
      <span className="badge-container tw:flex tw:items-center tw:justify-center">
        {icon}
        <span className="row x-center absolute text small badge px4">
          {badge}
        </span>
      </span>
    )
  }

  private onClickDefault = (evt: React.SyntheticEvent) => {
    evt.stopPropagation()

    this.props.navBarStore.displayView(this.props.route)
  }

  private get isActive() {
    const { route, navBarStore, state } = this.props
    const { location } = navBarStore

    return (
      route &&
      location.pathname.includes(
        getTransitionPath(route, state.activeOrInitProjectCode),
      )
    )
  }
}
